import { useMutation, useQueryClient } from '@tanstack/react-query';
import { uploadScriptFile } from '../api/uploads';
import { uploadsKeys } from '../queryKeys';

const useUploadFile = (userId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: uploadScriptFile,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: uploadsKeys.history(userId) });
    },
  });
};

export default useUploadFile;
